import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
    Message,
    List
} from 'semantic-ui-react';
import Alert from "../../components/extras/Alert";

import CustomDivider from "../extras/CustomDivider";
import localDB from "../../data/localDB";
import Loading from "../extras/Loading";
import DataService from "../../functions/DataService";

class AdditionsDialog extends Component {

    constructor() {
        super();

        this.state = {
            additions: [],
            options: [],
            additional_error: false,
            product:{
              name: '',
              id: null
            },
            addition: null,
            loading: true,
            loading_add:false,
            is_open: false,
        };
        this.loadData = this.loadData.bind(this);
        this.alert = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async fetchData(product_id) {
        let additions = await DataService.get(`additions/${product_id}`)
        this.setState({additions, loading: false})
    }

    loadData() {
        localDB.getDB('products').then(products => {
            let options = products.filter(
                product => {
                    return product.id !== this.state.product.id &&
                        product.active &&
                        product.product_type === 'U' &&
                        !product.variant_parent
                }
            ).map(product => {return {key:product.id, value:product.id, text:product.name}});
            this.setState({options});
        });
    };

    handleOpen = (product) => {
        this.setState({product, is_open: true})
        this.loadData()
        this.fetchData(product.id)
    }

    handleClose = () => {
        this.setState({is_open: false, loading: false, product: {name: '', id: null}, additions: []});
    };

    handleChange = (e, { name, value }) => {
        this.setState({[name]: value, additional_error:false, quantity_error:false});
    };

    handleSubmit() {
        if(this.state.addition === null){
            this.setState({additional_error:true});
        }else {
            let data = {addition: this.state.addition};
            this.add(data);
        }
    };

    add(data) {
        this.setState({loading_add:true});
        DataService.post(data,`additions/${this.state.product.id}`, (res) =>{
            if(res.add){
                localDB.addOrUpdateDB('products', res.for_sale);
                this.fetchData(this.state.product.id)
            }
            this.setState({loading_add:false})
        });
    };

    handleRemove = (addition_id) => {
        this.setState({[addition_id]: true})
        DataService.delete(`additions/${this.state.product.id}?addition=${addition_id}`, (res) =>{
            if(res.delete){
                localDB.addOrUpdateDB('products', res.for_sale);
                this.fetchData(this.state.product.id)
            }
            this.setState({[addition_id]: false})
        });
    }

    render() {
        let listItems = this.state.additions.map(function (addition) {
            return (
                <List.Item>
                    <List.Content floated='right'>
                        <Button.Group size='small' color='orange'>
                            <Button
                                icon='trash'
                                onClick={() => this.handleRemove(addition.id)}
                                loading={this.state[addition.id]}
                                disabled={this.state[addition.id]}/>
                        </Button.Group>
                    </List.Content>
                    <List.Content style={{paddingTop:10}}>{addition.name}</List.Content>
                </List.Item>
            )
        }, this);

        let data = (this.state.additions.length > 0 ? listItems :
                <Message icon='bell' header='No hay información registrada'/>
        );

        return (
            <div>
                <Modal open={this.state.is_open} dimmer='inverted' size='tiny' onClose={this.handleClose}>
                    <Modal.Header>{`${this.state.product.name} - Adicionales`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group>
                                    <Form.Dropdown
                                        options={this.state.options}
                                        placeholder='Adicional'
                                        name='addition'
                                        onChange={this.handleChange}
                                        search
                                        selection
                                        width={11}
                                        error={this.state.additional_error}
                                    />
                                    <Form.Button
                                        icon='add'
                                        primary
                                        content='Agregar'
                                        disabled={this.state.loading_add}
                                        loading={this.state.loading_add}
                                    />
                                </Form.Group>
                            </Form>
                            <CustomDivider/>
                            <div>
                                <List divided verticalAlign='middle'>
                                    {this.state.loading ? <Loading /> : data}
                                </List>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
            </div>
        );
    }
}

export default AdditionsDialog


// WEBPACK FOOTER //
// ./src/components/inventories/AdditionsDialog.js